import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select
} from "@mui/material"

const PublicMultiSelectOption = ({
  id,
  label,
  value,
  onChange,
  options,
  error = false,
  describedBy,
  required = false,
  style
}) => {
  const selectedValues = Array.isArray(value) ? value : []
  const optionList = Array.isArray(options) ? options : []
  const labelId = `${id}-label`

  return (
    <FormControl
      sx={style}
      error={error}
      required={required}
      aria-describedby={describedBy}
    >
      <InputLabel id={labelId}>
        {label}
      </InputLabel>
      <Select
        id={id}
        name={id}
        labelId={labelId}
        label={label}
        multiple
        value={selectedValues}
        onChange={onChange}
        MenuProps={{
          PaperProps: {
            elevation: 0,
            sx: {
              mt: 1,
              borderRadius: "10px",
              border: "1px solid #E5E7EB",
              boxShadow: "0 12px 28px rgba(15, 23, 42, 0.12)",
              overflow: "hidden",
              "& .MuiList-root": { py: 0.75 },
              "& .MuiMenuItem-root": {
                mx: 0.75,
                my: 0.25,
                borderRadius: "8px",
                color: "#2F3744",
                transition: "background-color 160ms ease",
                "&:hover": { backgroundColor: "#F1F4F8" },
                "&.Mui-selected": {
                  backgroundColor: "#EEF5FF"
                }
              }
            }
          }
        }}
        sx={{
          borderRadius: "8px",
          backgroundColor: "#fff",
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "#D8DDE6" },
          "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#AEB6C3" },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0B5CAD",
            borderWidth: 1
          }
        }}
        inputProps={{
          "aria-label": label,
          "aria-labelledby": labelId,
          "aria-describedby": describedBy,
          style: {
            backgroundColor: "#ffffff",
            border: 0,
            clipPath: "inset(50%)",
            color: "#111111",
            fontSize: 0,
            height: 1,
            margin: -1,
            opacity: 1,
            outline: 0,
            overflow: "hidden",
            padding: 0,
            pointerEvents: "none",
            position: "absolute",
            whiteSpace: "nowrap",
            width: 1
          }
        }}
        renderValue={selected => selected.join(", ")}
        aria-describedby={describedBy}
        aria-invalid={error ? "true" : undefined}
      >
        {optionList.map(option => (
          <MenuItem key={option} value={option}>
            <Checkbox
              checked={selectedValues.includes(option)}
              inputProps={{
                "aria-label": `${label}: ${option}`
              }}
            />
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default PublicMultiSelectOption
